import React, { Component } from 'react';

class IconTextTile extends Component {
  constructor() {
    super();
    this.state = {
      mouseOver: false,
    };
  }
  onMouseOver = () => this.setState({ mouseOver: true });
  onMouseLeave = () => this.setState({ mouseOver: false });

  render() {
    const {
      text,
      Icon,
      onClick,
      iconColor,
      tooltip,
    } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          cursor: 'pointer',
          padding: '4px 8px',
          backgroundColor: this.state.mouseOver ? '#e0e0e0' : 'transparent',
          whiteSpace: 'pre-wrap',
        }}
        onMouseEnter={this.onMouseOver}
        onMouseLeave={this.onMouseLeave}
        onClick={onClick}
      >
        <Icon color={iconColor || 'rgba(0, 0, 0, 0.87)'}/>
        {
          tooltip
          ? (
              <div
                className="hint--bottom hint--large hint--rounded"
                aria-label={tooltip}
              >
                {text}
              </div>
            ) : (
              <div style={{ textAlign: 'center', fontSize: '1em' }}>
                {text}
              </div>
            )
        }
      </div>
    );
  }
}

export default IconTextTile;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/template-draft-toolbar/icon-text-tile.jsx